module.exports = __webpack_public_path__ + "img/关闭历史文件.55063460.svg";